var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Vietnam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#d32f2f"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffeb3b",
    d: "M27.055,25.594L32,22h-6.109L24,16.188L22.109,22H16l4.945,3.594l-1.891,5.813L24,27.813l4.945,3.594 L27.055,25.594z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Vietnam);
export default __webpack_public_path__ + "static/media/icons8-vietnam.7c905432fa1e682f53e24f8ed6c8ed40.svg";
export { ForwardRef as ReactComponent };